// extracted by css-extract-rspack-plugin
export default {"ActionList_LinkItem":"LinkedPullRequests-module__ActionList_LinkItem__gN__z"};